import {api} from '~/CreateFabricInvitation/api/api';
import {Address, Place} from '~/common/types/location';

export const addressCompleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addressComplete: builder.query<{results: Place[]}, string>({
      query: (query: string) => ({
        url: `/v1/address-complete?session_token=${window.user_id}&query=${encodeURIComponent(query)}`,
        method: 'GET',
      }),
    }),
    addressDetails: builder.query<Address, string>({
      query: (placeId: string) => ({
        url: `/v1/address-details?session_token=${window.user_id}&place_id=${placeId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {useLazyAddressCompleteQuery, useLazyAddressDetailsQuery} = addressCompleteApi;
